import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-grupo-listar',
  templateUrl: './grupo-listar.component.html',
  styleUrls: ['./grupo-listar.component.scss']
})
export class GrupoListarComponent implements OnInit {

  permissaoListar: boolean = false;
  permissaoInserir: boolean = false;
  loadingGrupos: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  grupos: Grupo[] = [];
  tiposGrupo: SelectItem[] = [
    { label: 'TODOS', value: null },
    { label: 'PRODUTO', value: 3 },
    { label: 'SERVIÇO', value: 4 }];
  tipoGrupoSelecionado?: number;

  constructor(private grupoService: GrupoService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    private erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) {
    
  }

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.loadingGrupos = true;
    this.permissaoListar = this.verificarPermissao("PERM_LISTAR_GRUPO");
    this.permissaoInserir = this.verificarPermissao("PERM_INSERIR_GRUPO");
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoListar) {
      this.listarGrupos();
    }
  }

  listarGrupos() {
    const empresaId = this.empresaSelecionada?.id
    if (this.tipoGrupoSelecionado === 3 || this.tipoGrupoSelecionado === 4) {
      this.grupoService.listarGruposPorEmpresaECodigoPlanoConta(
        empresaId, this.tipoGrupoSelecionado).subscribe({
        next: (data: Grupo[]) => {
          this.loadingGrupos = false;
          this.grupos = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      });

    } else {
      this.grupoService.listarGrupos(empresaId).subscribe({
        next: (data: Grupo[]) => {
          this.loadingGrupos = false;
          this.grupos = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      });
    }

  }

  excluirGrupo(grupoId: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.grupoService.excluirGrupo(grupoId).subscribe({
          next: () => {
            this.listarGrupos();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
            this.rolarTela();

          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        });

      }
    });
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  editarGrupo(id: number) {
    this._router.navigate(["/apps/grupo/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalharGrupo(id: number) {
    this._router.navigate(["/apps/grupo/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
